// extracted by mini-css-extract-plugin
module.exports = {"logo_img":"Header_logo_img__1am8o"};